import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

const REDIRECT = 'sckrg/redirect/REDIRECT';
const LOGIN = 'sckrg/auth/LOGIN';
const LOGOUT = 'sckrg/auth/LOGOUT';

const redirectTo = handleActions(
  {
    [REDIRECT]: {
      next: () => null,
    },

    [LOGIN]: {
      next: (state, { payload }) => {
        const role = payload?.roles?.[0];
        if (!role) return '/';

        if (role.name === 'superadmin' || role.name === 'admin') {
          return '/';
        }

        let url = payload.homePage;

        if (!url) {
          const firstTabUrl = role.tabs?.[0]?.url;
          url = firstTabUrl || null;
        }

        if (!url) {
          return '/';
        }

        if (url.startsWith('/')) {
          return url;
        }

        const parts = url.split('cc.krgsc.kz');
        if (parts.length > 1 && parts[1]) {
          return parts[1];
        }

        return '/';
      },
    },

    [LOGOUT]: {
      next: () => '/signin',
    },
  },
  null
);

export default combineReducers({
  redirect: combineReducers({
    redirectTo,
  }),
});
